"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEntityAdapter = void 0;

var _createInitialStateFactory = require("./createInitialStateFactory");

var _createSelectorsFactory = require("./createSelectorsFactory");

var _createUnsortedStateAdapter = require("./createUnsortedStateAdapter");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createEntityAdapter = function createEntityAdapter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var _options$getId = options.getId,
      getId = _options$getId === void 0 ? function (instance) {
    return instance.id;
  } : _options$getId,
      _options$sortComparer = options.sortComparer,
      sortComparer = _options$sortComparer === void 0 ? false : _options$sortComparer;
  var selectorsFactory = (0, _createSelectorsFactory.createSelectorsFactory)();
  var stateFactory = (0, _createInitialStateFactory.createInitialStateFactory)();
  var unsortedAdapter = (0, _createUnsortedStateAdapter.createUnsortedStateAdapter)(getId);
  return _objectSpread(_objectSpread(_objectSpread({
    getId: getId,
    sortComparer: sortComparer
  }, selectorsFactory), stateFactory), unsortedAdapter);
};

exports.createEntityAdapter = createEntityAdapter;